export default "__VITE_ASSET__b650da79__"